module.exports = __webpack_public_path__ + "img/mobile-cross.69f256d2.svg";